import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardWidgetsComponent } from './dashboard/dashboard-widgets/dashboard-widgets.component';
import { PlatformShellFeatureDashboardRoutingModule } from './platform-shell-feature-dashboard-routing.module';
import { TranslocoModule } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { NotificationBannerComponent } from './dashboard/notification-banner/notification-banner.component';
import { DashboardWidgetSelectionComponent } from './dashboard/dashboard-widget-selection/dashboard-widget-selection.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SharedUiInfoCalloutModule } from '@markant-platform/shared/ui-info-callout';
import { GridsterComponent, GridsterItemComponent } from 'angular-gridster2';
import { AddWidgetComponent } from './dashboard/dashboard-widgets/widget/add-widget-widget/add-widget-widget.component';
import { CartridgeWidgetComponent } from './dashboard/dashboard-widgets/widget/cartridge-widget/cartridge-widget.component';
import { WidgetComponent } from './dashboard/dashboard-widgets/widget/widget.component';
import { ModuleFederationToolsModule } from '@angular-architects/module-federation-tools';
import { WidgetContextMenuComponent } from './dashboard/dashboard-widgets/widget/widget-context-menu/widget-context-menu.component';
import { CartridgeDataAccessModule } from '@markant-platform/cartridge/data-access';
import { StaticWidgetsDashboardComponent } from './dashboard/dashboard-widgets/static-widgets-dashboard/static-widgets-dashboard.component';
import {
  ArrayIncludesPipe,
  PercentagePipe,
  StringIncludePipe,
  TypeCastPipe,
} from '@markant-platform/shared/util-pipes';
import {
  AdminWidgetComponent,
  BaseRequestsWidgetComponent,
  ContactRequestsWidgetComponent,
  FurtherQualificationProgressWidgetComponent,
  FurtherQualificationStartWidgetComponent,
  GuidedTourAdminAreaComponent,
  GuidedTourWidgetComponent,
  OrderRequestsWidgetComponent,
  PlatformRequestsWidgetComponent,
  PriceRequestsWidgetComponent,
} from './dashboard/dashboard-widgets/widget/platform-widget';
import { GetSelectedWidgetClassPipe } from './dashboard/utils/get-selected-widget-class.pipe';
import { BaseRequestsWidgetV2Component } from './dashboard/dashboard-widgets/widget/platform-widget/base-requests-widget-v2/requests-widget-v2.component';
import { WidgetAlertComponent } from './dashboard/dashboard-widgets/widget/widgetAlert/widgetAlert.component';
import { WidgetDemoChipComponent } from './dashboard/dashboard-widgets/widget/widget-demo-chip/widget-demo-chip.component';
import { CompleteProfileDialogComponent } from '@markant-platform/shared/organization/feature';

@NgModule({
  imports: [
    CommonModule,
    PlatformShellFeatureDashboardRoutingModule,
    TranslocoModule,
    MarkantElementsModule,
    SharedUiInfoCalloutModule,
    GridsterComponent,
    GridsterItemComponent,
    ModuleFederationToolsModule,
    WidgetContextMenuComponent,
    CartridgeDataAccessModule,
    ArrayIncludesPipe,
    PercentagePipe,
    TypeCastPipe,
    GuidedTourWidgetComponent,
    StringIncludePipe,
    GetSelectedWidgetClassPipe,
    BaseRequestsWidgetV2Component,
    WidgetAlertComponent,
    WidgetDemoChipComponent,
    CompleteProfileDialogComponent,
  ],
  declarations: [
    DashboardWidgetsComponent,
    NotificationBannerComponent,
    DashboardWidgetSelectionComponent,
    DashboardComponent,
    AddWidgetComponent,
    CartridgeWidgetComponent,
    AdminWidgetComponent,
    WidgetComponent,
    FurtherQualificationStartWidgetComponent,
    FurtherQualificationProgressWidgetComponent,
    PlatformRequestsWidgetComponent,
    OrderRequestsWidgetComponent,
    ContactRequestsWidgetComponent,
    BaseRequestsWidgetComponent,
    PriceRequestsWidgetComponent,
    StaticWidgetsDashboardComponent,
    GuidedTourAdminAreaComponent,
  ],
})
export class PlatformShellFeatureDashboardModule {}
